// Pages
import { ActivityTeacherDashboard } from "./activity-teacher-dashboard.page";

export default ActivityTeacherDashboard;
